import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { GradientBackground } from './components/index';
import { router } from './Routes';
import { AuthProvider } from './module/AuthenticationModule';
import { AuthProvider as CoreAuthProvider } from './module/AuthContext';
import GlobalFonts from './asset/fonts/font';
import { useThemeContext } from './hook/useThemeManager';
import { theme } from './constants/theme';
import { Box } from '@mui/material';
import { MessageContextProvider } from './module/MessageContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { captureReferralCodeFromWindow } from './utils/referralCapture';
function App() {
    const { themeStyle, toggleView } = useThemeContext();

    useEffect(() => {
        try {
            const view = localStorage.getItem('view');
            if (view) toggleView(view);
        } catch {
            // localStorage unavailable in some WebView environments (e.g. Facebook in-app browser)
        }
    }, [toggleView]);

    // Capture ?ref= / ?referral_code= as early as possible (before navigation drops query).
    useEffect(() => {
        captureReferralCodeFromWindow();
    }, []);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CoreAuthProvider>
                <GradientBackground
                    style={{
                        flex: 1,
                        alignItems: 'center',
                        width: '100%',
                        justifyContent: 'center',
                        height: '100%',
                        backgroundColor: theme[themeStyle].pure_black,
                    }}>
                    <AuthProvider>
                        <MessageContextProvider>
                            <Box
                                sx={{
                                    alignContent: 'center',
                                    flex: 1,
                                    overflow: 'hidden',
                                }}>
                                <GlobalFonts />
                                <RouterProvider router={router} />
                                <ToastContainer position="bottom-right" />
                            </Box>
                        </MessageContextProvider>
                    </AuthProvider>
                </GradientBackground>
            </CoreAuthProvider>
        </LocalizationProvider>
    );
}

export default App;
